(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('Mould', Mould);

    Mould.$inject = ['$resource'];

    function Mould ($resource) {
        var resourceUrl =  'manager/' + 'api/moulds/:path/:id';

        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
